/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

// @module CMSadapter
define(
	'CMSadapter.Page.Model'
,	[
		'Backbone'
	]
,	function (
		Backbone
	)
{
	'use strict';

	// @class CMSadapter.Page.Model Model for handling CMS landing and enhanced pages @extends Backbone.Model
	return Backbone.Model.extend({
	});
});

